import { FINANCEIRO_STATUS_OPTIONS, findFinanceiroStatus } from "./financeiro-obras.types";

interface StatusParaRotulo {
  codigo: string;
  descricao?: string | null;
}

/** Enum de FEL fora do cadastro ainda aparece com hífen; qualquer outro texto fica como veio. */
function semUnderscoreDeFel(texto: string): string {
  return texto.replace(/^(FEL)_(\d)$/, "$1-$2");
}

/**
 * Rótulo único do status financeiro (tag da Lista, Cards, Detalhamento e Status FEL das fichas):
 * "FEL-0" a "FEL-4" com hífen, nunca o texto do enum. `abreviado` dá a sigla da tag (EXEC, FECH).
 */
export function formatarStatusFinanceiro(
  status: StatusParaRotulo,
  { abreviado = false }: { abreviado?: boolean } = {},
): string {
  const conhecido = findFinanceiroStatus(status.codigo);
  if (conhecido) return abreviado ? conhecido.abreviacao : conhecido.descricao;

  return semUnderscoreDeFel(status.descricao || status.codigo);
}

const CODIGOS_EM_FECHAMENTO: readonly string[] = ["FECHAMENTO", "POS_AUDIT"];

export function obraEmFechamento(status: string | null | undefined): boolean {
  const opcao = FINANCEIRO_STATUS_OPTIONS.find(
    (item) => item.codigo === status || item.descricao === status,
  );
  return opcao !== undefined && CODIGOS_EM_FECHAMENTO.includes(opcao.codigo);
}
